<template>
    <div class="main-content events-list">
        <div class="container">
            <div class="events-group-sorting">
                <div class="events-group-sorting-left">
                    <span class="icon icon-sort-down"></span>{{ sortedByLabel }}
                </div>
                <div class="events-group-sorting-right">
                    <icon-dropdown
                        @selected="doAction"
                        :options="[
                            {
                                label: 'By deadline',
                                value: 'sorted_deadline'
                            }
                        ]"
                        icon_class="icon icon-sort"
                    ></icon-dropdown>
                </div>
            </div>
            <div
                class="events events-group"
                style="padding-top:0; overflow: auto;"
                :style="{ height: `${events_list_container_height}px` }"
                ref="scrollContainer"
                id="events-list-container"
            >
                <infinite-loading
                    ref="infiniteLoading"
                    v-if="enable_list_loading"
                    infinite-scroll-disabled="busy"
                    infinite-scroll-distance="30"
                    direction="top"
                    @infinite="load_more_past_events"
                >
                    <div slot="no-more"></div>
                </infinite-loading>
                <div v-for="(month_events, i) in task_events">
                    <event-group
                        :ref="'month_' + i"
                        :i="i"
                        :t="month_events"
                        :key="Object.keys(month_events).toString()"
                    ></event-group>
                </div>
                <infinite-loading
                    ref="infiniteLoadingDown"
                    v-if="enable_list_loading_down"
                    infinite-scroll-disabled="busy"
                    infinite-scroll-distance="30"
                    @infinite="load_more_future_events"
                >
                    <div slot="no-more"></div>
                </infinite-loading>
            </div>
        </div>
    </div>
</template>

<script>
import iconDropdown from "@/components/pages/icon-dropdown.vue";
import { mapActions, mapMutations, mapState } from "vuex";
import InfiniteLoading from "vue-infinite-loading";
import EventGroup from "./event-group";
import Vue from "vue";

export default {
    name: "tasks-page",

    mounted() {
        this.clear_tasks();
        this.get_list_events(false);
        this.calculate_height();
        this.scroll_to_current_month();
    },
    computed: {
        ...mapState("StoreTask", ["task_events", "events"])
    },
    components: {
        EventGroup,
        iconDropdown,
        InfiniteLoading
    },
    data() {
        return {
            sortedBy: "sorted_deadline",
            sortedByLabel: "By deadline",
            dropShown: false,
            busy: false,
            cal_busy: false,
            enable_list_loading: false,
            enable_list_loading_down: false,
            show_loader_up: false,
            show_loader_down: false,
            current_list_page: 0,
            current_list_min_page: 0,
            events_list_container_height: 0,
            user: {
                email: null,
                password: null,
                facebook_id: null
            }
        };
    },
    created() {
        window.addEventListener("resize", this.resized);
    },
    methods: {
        ...mapActions("StoreTask", ["get_task_events"]),
        ...mapMutations("StoreTask", ["clear_tasks"]),
        calculate_height() {
            Vue.nextTick(() => {
                if (document.getElementById("main-menu")) {
                    this.events_list_container_height =
                        window.innerHeight - document.getElementById("main-menu").clientHeight - 450;

                    if (
                        document.getElementsByClassName("footer-mobile")[0] &&
                        document.getElementsByClassName("footer-mobile")[0].style.display !== "none"
                    ) {
                        this.events_list_container_height =
                            window.innerHeight -
                            document.getElementsByClassName("footer-mobile")[0].clientHeight -
                            document.getElementsByClassName("events-group-sorting")[0].clientHeight -
                            document.getElementById("main-menu").clientHeight -
                            124;
                    }
                }
            });
        },
        resized() {
            this.calculate_height();
        },
        load_more_past_events() {
            let timer;
            if (timer) {
                window.clearTimeout(timer);
            }
            timer = window.setTimeout(() => {
                this.current_list_page += 1;
                this.get_list_events(this.current_list_page);
            }, 1000);
        },
        async get_list_events(current_page = false) {
            this.busy = true;
            let result = await this.get_task_events(current_page);
            if (result) {
                Vue.nextTick(() => {
                    if (current_page) {
                        //$containerElement.scrollTop = $currentElement.offsetTop;
                        this.busy = false;
                        if (current_page < 0) {
                            if (this.$refs.infiniteLoadingDown) {
                                this.$refs.infiniteLoadingDown.$emit("$InfiniteLoading:loaded");
                            }
                            if (current_page < -3) {
                                if (this.$refs.infiniteLoadingDown) {
                                    this.$refs.infiniteLoadingDown.$emit("$InfiniteLoading:complete");
                                }
                            }
                        } else {
                            if (this.$refs.infiniteLoading) {
                                this.$refs.infiniteLoading.$emit("$InfiniteLoading:loaded");
                            }
                            if (current_page < 3) {
                                if (this.$refs.infiniteLoading) {
                                    this.$refs.infiniteLoading.$emit("$InfiniteLoading:complete");
                                }
                            }
                        }
                    } else {
                        Vue.nextTick(() => {
                            this.scroll_to_current_month();
                            setTimeout(() => {
                                this.enable_list_loading = true;
                                this.enable_list_loading_down = true;
                            }, 500);
                            //this.current_list_min_page = -1;
                            this.current_list_page = 1;
                        });
                    }
                });
            }
        },
        load_more_future_events() {
            let timer;
            if (timer) {
                window.clearTimeout(timer);
            }
            timer = window.setTimeout(() => {
                this.current_list_min_page -= 1;
                this.get_list_events(this.current_list_min_page);
            }, 1000);
        },
        scroll_to_current_month() {
            Vue.nextTick(() => {
                let $currentElement = document.getElementsByClassName("is-current")[0];
                let $containerElement = this.$refs.scrollContainer;
                if ($currentElement) {
                    $containerElement.scrollTop = $currentElement.offsetTop - 100;
                }
            });
        },
        showDrop() {
            this.dropShown = !this.dropShown;
        },
        doAction(pl) {
            this.sortedByLabel = pl.label;
        }
    }
};
</script>

<style scoped>
.events {
    padding-top: 0 !important;
}

.drop-content {
    right: 0;
}

@media (max-width: 82rem) {
    .main-content {
        height: 60vh;
        overflow: auto;
    }
}

.main-content.events-list {
    padding-top: 13px;
}
</style>
